import React, { useState } from 'react';
import LoanCalculator from '../Home';
import { tableData } from './testy/danedowyliczen';

function PaymentRate2(props) {
    let creditValue = props.creditValue;
    let interestRate = props.interestRate/1200;
    //let interestRate = <CalculateInterest creditValue={creditValue} LTV={0.75}/>
    
    let loanPeriod = props.loanPeriod;
    const firstYearInterest = (creditValue*interestRate*Math.pow(1 + interestRate, 12)) / (Math.pow(1 + interestRate, 12) - 1);
    //const after5YearsInterest = 
    const paymentRate2 = (creditValue*interestRate*Math.pow(1 + interestRate, loanPeriod)) / (Math.pow(1 + interestRate, loanPeriod) - 1);
    return paymentRate2.toFixed(2);
  }

  
function PaymentRateDecreasing(props) {
  let interestRate = props.interestRate/1200;
  let loanPeriod = props.loanPeriod;
 // let paymentRate2 = creditValue +5;
  const paymentRateDecreasing = (props.creditValue/loanPeriod) + (interestRate*props.creditValue);
  return paymentRateDecreasing.toFixed(2);
}

function TotalCost(props) {
  let creditValue = props.creditValue;
  let interestRate = props.interestRate/1200;
  let loanPeriod = props.loanPeriod;
  let commission = (props.commission * creditValue)/100;
  let paymentRate2 = props.paymentRate2;
  let creditValue1 = props.creditValue;
  let lifeInsurance1 = props.lifeInsurance;
  let insurancePeriod1 = props.insurancePeriod;
  let lifeInsuranceTotal1 = 0;
  let firstYearInterest = props.firstYearInterest;
  let wibor = props.wibor;

  
  for (let i = 0; i < insurancePeriod1; i++) {
    creditValue1 = (creditValue1 - (paymentRate2 - ((creditValue1 * interestRate))));
    lifeInsuranceTotal1 = lifeInsuranceTotal1 + (creditValue1 * lifeInsurance1);
  }

  
  const totalCost = (loanPeriod * (creditValue*interestRate*Math.pow(1 + interestRate, loanPeriod)) / (Math.pow(1 + interestRate, loanPeriod) - 1)) - creditValue;

  return totalCost.toFixed(2);
} 

function TotalCostInne(props){
let creditValue = props.creditValue;
let comission = props.comission*creditValue/100;
let ubNieruchomości = props.ubNieruchomości;

let lifeInsurance = props.lifeInsurance;

  let loanPeriod = props.loanPeriod;
  let interestRate = props.interestRate/1200;
  let paymentRate2 = (creditValue*interestRate*Math.pow(1 + interestRate, loanPeriod)) / (Math.pow(1 + interestRate, loanPeriod) - 1);
  let creditValue2 = creditValue;
  let insurancePeriod = props.insurancePeriod;
  let lifeInsuranceTotal = 0;
  let ubPraca = props.ubPraca*creditValue/100;
  
  if(props.jakaSkładka === "Miesięcznie"){
  for (let i = 0; i < insurancePeriod; i++) {
     creditValue2 = (creditValue2 - (paymentRate2 - ((creditValue2 * interestRate))));
     lifeInsuranceTotal = lifeInsuranceTotal + (creditValue2 * lifeInsurance);
 }
}
  if(props.jakaSkładka === "Jednorazowo"){ lifeInsuranceTotal = props.creditValue * props.lifeInsurance}
  if(props.jakaSkładka === "Brak") {lifeInsuranceTotal = 0};


let totalCostInne = ubPraca + comission + lifeInsuranceTotal + ubNieruchomości;


return totalCostInne.toFixed(2);

}

function TotalCostPkobp(props) {
  let creditValue = props.creditValue;
  let creditValue2 = 0;
  let interestRate = props.interestRate/1200;
  let loanPeriod = props.loanPeriod;
  let commission = (props.commission * creditValue)/100;
  let paymentRate2 = props.paymentRate2;
  let creditValue1 = props.creditValue;
  let lifeInsurance1 = props.lifeInsurance;
  let insurancePeriod1 = props.insurancePeriod;
  let lifeInsuranceTotal1 = 0;
  let firstYearInterest = props.firstYearInterest;
  let wibor = props.wibor;
  let firstYearInterest1 = (firstYearInterest + wibor)/1200;
  let paymentRate3 = (creditValue*firstYearInterest1*Math.pow(1 + firstYearInterest1, loanPeriod)) / (Math.pow(1 + firstYearInterest1, loanPeriod) - 1);
 // let totalCostFirstYear = 0;
 


  for (let i = 0; i < insurancePeriod1; i++) {
    creditValue1 = (creditValue1 - (paymentRate2 - ((creditValue1 * interestRate))));
    lifeInsuranceTotal1 = lifeInsuranceTotal1 + (creditValue1 * lifeInsurance1);
  }

  for (let i = 0; i <= 12; i++) {
 
    creditValue2 = (creditValue - (paymentRate3 - ((creditValue * firstYearInterest1))));
   
 }


  if(loanPeriod <= 12){
     const totalCostFirstYear = (12 * (creditValue*firstYearInterest1*Math.pow(1 + firstYearInterest1, loanPeriod)) / (Math.pow(1 + firstYearInterest1, loanPeriod) - 1));
     const totalCostPkobp = totalCostFirstYear;
   
    return totalCostPkobp.toFixed(2);
    }
  
  if(loanPeriod > 12){
    let loanPeriodPko = loanPeriod - 12;
    const totalCostFirstYear = (12 * (creditValue*firstYearInterest1*Math.pow(1 + firstYearInterest1, 12)) / (Math.pow(1 + firstYearInterest1, 12) - 1)) - creditValue;
    const totalCostPkobp = totalCostFirstYear + (loanPeriodPko * (creditValue2*interestRate*Math.pow(1 + interestRate, loanPeriodPko)) / (Math.pow(1 + interestRate, loanPeriodPko) - 1));
  
    return totalCostPkobp.toFixed(2) - creditValue;
  }
    
  
} 

function TotalCostFixed(props){
  let creditValue = props.creditValue;
  let loanPeriod = props.loanPeriod;
  let interestRate = props.interestRate/1200;
  let interestRateVariable = props.interestRateVaribale/1200;
  let commission = (props.commission * creditValue)/100;
  let paymentRate2 = (creditValue*interestRate*Math.pow(1 + interestRate, loanPeriod)) / (Math.pow(1 + interestRate, loanPeriod) - 1);
  let creditValue2 = props.creditValue2;
  let creditValue4 = props.creditValue;
  let fixedPeriod = props.fixedPeriod;
  let insurancePeriod = props.insurancePeriod;
  let lifeInsurance = props.lifeInsurance;
  let lifeInsuranceTotal = 0;

  let shortLoanPeriod = fixedPeriod * 12;
  let longLoanPeriod = loanPeriod - shortLoanPeriod;
  
  const totalCost = (shortLoanPeriod * (creditValue*interestRate*Math.pow(1 + interestRate, shortLoanPeriod)) / (Math.pow(1 + interestRate, shortLoanPeriod) - 1));
  //const totalCostFirstYear = (loanPeriod * (creditValue*interestRate*Math.pow(1 + interestRate, 12)) / (Math.pow(1 + interestRate, 12) - 1)) ;
  
 
 // const principal = (paymentRate2 - ((creditValue2 * 8/1200)))

  for (let i = 0; i < shortLoanPeriod; i++) {
 
    creditValue2 = (creditValue2 - (paymentRate2 - ((creditValue2 * interestRate))));
 }

 for (let i = 0; i < insurancePeriod; i++) {
  creditValue4 = (creditValue4 - (paymentRate2 - ((creditValue4 * interestRate))));
  lifeInsuranceTotal = lifeInsuranceTotal + (creditValue4 * lifeInsurance);
}
 
const totalCostAfterFixed = (loanPeriod * (creditValue2*interestRateVariable*Math.pow(1 + interestRateVariable, loanPeriod)) / (Math.pow(1 + interestRateVariable, loanPeriod) - 1));
  const totalCostFixed = totalCost + totalCostAfterFixed - creditValue + lifeInsuranceTotal;
 return totalCostFixed.toFixed(2);
}

function TestTotalCost (props){

  let creditValue2 = props.creditValue;
  let principal = 666;
  for (let i = 0; i < 10; i++) {
     creditValue2 = (creditValue2 - principal);
 }
  return creditValue2;
}

function TotalCostDecreasing(props){
  let creditValue = props.creditValue;
  let interestRate = props.interestRate/1200;
  let loanPeriod = props.loanPeriod;
  let paymentRate2 = (creditValue*interestRate*Math.pow(1 + interestRate, loanPeriod)) / (Math.pow(1 + interestRate, loanPeriod) - 1);
  let creditValue2 = props.creditValue2;
  let commission = (props.commission * creditValue)/100;
  let creditValue5 = props.creditValue;
  let insurancePeriod2 = props.insurancePeriod;
  let lifeInsurance2 = props.lifeInsurance;
  let lifeInsuranceTotal2 = 0;


  const TotalCostDecreasing = ((interestRate*props.creditValue)+ ((props.creditValue/props.loanPeriod)*interestRate)) * props.loanPeriod/2;

  return TotalCostDecreasing.toFixed(2);
}

function TotalCostDecreasingPkoBp(props){
  let creditValue = props.creditValue;
  let interestRate = props.interestRate/1200;
  let loanPeriod = props.loanPeriod;
  let commission = (props.commission * creditValue)/100;
  let paymentRate2 = props.paymentRate2;
  let creditValue1 = props.creditValue;
  let lifeInsurance1 = props.lifeInsurance;
  let insurancePeriod1 = props.insurancePeriod;
  let lifeInsuranceTotal1 = 0;
  let firstYearInterest = props.firstYearInterest;
  let wibor = props.wibor;
  let firstYearInterest1 = (firstYearInterest + wibor)/1200;
  let paymentRate3 =  (props.creditValue/loanPeriod) + (firstYearInterest1*props.creditValue);
  let creditValue2 = (creditValue/loanPeriod) * 12; 
  let creditValue3 = creditValue - creditValue2
  let creditValue5 = props.creditValue;
  let insurancePeriod2 = props.insurancePeriod;
  let lifeInsurance2 = props.lifeInsurance;
  let lifeInsuranceTotal2 = 0;


  if(loanPeriod <= 12){
    const totalCostDecreasingPkoBp =((firstYearInterest1*creditValue)+ ((creditValue/loanPeriod)*firstYearInterest1)) * loanPeriod/2;

     
    return totalCostDecreasingPkoBp.toFixed(2);
    }
  
  if(loanPeriod > 12){
    let loanPeriodPkoBp = loanPeriod - 12;
    const totalCostDecreasingPkoBpFirstYear = ((firstYearInterest1*creditValue)+ ((creditValue/12)*firstYearInterest1)) * 6;
    const totalCostDecreasingPkoBp = lifeInsuranceTotal2  + creditValue3 + ((firstYearInterest1*creditValue3)+ ((creditValue3/loanPeriodPkoBp)*firstYearInterest1)) * loanPeriodPkoBp/2;
    console.log(totalCostDecreasingPkoBpFirstYear, totalCostDecreasingPkoBp)
    return totalCostDecreasingPkoBp.toFixed(2);
  }
    
  

  const TotalCostDecreasing = lifeInsuranceTotal2  + props.creditValue + ((interestRate*props.creditValue)+ ((props.creditValue/props.loanPeriod)*interestRate)) * props.loanPeriod/2;

  return TotalCostDecreasing;
}

function TotalCostDecreasingFixed(props){
  
  let creditValue = props.creditValue;
  let loanPeriod = props.loanPeriod;
  let interestRate = props.interestRate/1200;
  let interestRateVariable = props.interestRateVaribale/1200;
  let commission = (props.commission * creditValue)/100;
  let paymentRate2 = (creditValue*interestRate*Math.pow(1 + interestRate, loanPeriod)) / (Math.pow(1 + interestRate, loanPeriod) - 1);
  let creditValue2 = props.creditValue2;
  const fixedPeriod = props.fixedPeriod;
  let creditValue6 = props.creditValue;
  let insurancePeriod3 = props.insurancePeriod;
  let lifeInsurance3 = props.lifeInsurance;
  let lifeInsuranceTotal3 = 0;

  let shortLoanPeriod = fixedPeriod * 12;
  let longLoanPeriod = loanPeriod - shortLoanPeriod;
  
  const totalCostDecreasing = commission + creditValue + ((interestRate*creditValue)+ ((creditValue/shortLoanPeriod)*interestRate)) * shortLoanPeriod/2;
  //const totalCostFirstYear = (loanPeriod * (creditValue*interestRate*Math.pow(1 + interestRate, 12)) / (Math.pow(1 + interestRate, 12) - 1)) ;
  
 
 // const principal = (paymentRate2 - ((creditValue2 * 8/1200)))

  for (let i = 0; i < shortLoanPeriod; i++) {
 
    creditValue2 = (creditValue2 - (paymentRate2 - ((creditValue2 * interestRate))));
 }
 
 for (let i = 0; i < insurancePeriod3; i++) {
  creditValue6 = (creditValue6 - (paymentRate2 - ((creditValue6 * interestRate))));
  lifeInsuranceTotal3 = lifeInsuranceTotal3 + (creditValue6 * lifeInsurance3);
}
 
const totalCostDecreasingAfterFixed = ((interestRate*creditValue2)+ ((creditValue2/longLoanPeriod)*interestRate)) * longLoanPeriod/2;
  const totalCostDecreasingFixed = totalCostDecreasing + totalCostDecreasingAfterFixed + lifeInsuranceTotal3;
 return totalCostDecreasingFixed;
}

//to liczy RRSO
function Calculate(props){


      const interestRatePerMonth = props.interestRate / 100 / 12;
      const creditCost = props.amount * (props.commision / 100 + 1) + props.additionalCreditCosts;
      const fixedInstallment = Math.round(100 * (creditCost * interestRatePerMonth) * Math.pow((interestRatePerMonth + 1), props.installmentNumber) / ((Math.pow((interestRatePerMonth + 1), props.installmentNumber) - 1))) / 100;
      const amountToPayBack = Math.round(100 * fixedInstallment * props.installmentNumber) / 100;
      const interest = Math.round(100 * (amountToPayBack - props.amount)) / 100;
      const nominalInterest = (12 * (95 * props.installmentNumber + 9) * interest) / ((1 + parseFloat(props.installmentNumber)) * 12 * parseFloat(props.installmentNumber) * (4 * props.amount + interest));
      const rrso = Math.round((Math.pow(1 + nominalInterest / 12, 12) - 1) * 10000) / 100;
  

return rrso.toFixed(2);

}

//Liczy 1wszy rok niższej marży
//function FirstYearCost(props){

 // let creditValue = props.creditValue;
//  let flatValue = props.flatValue;

//  const totalCost = (12 * (creditValue*interestRate*Math.pow(1 + interestRate, 12)) / (Math.pow(1 + interestRate, 12) - 1));

//  return
//}


function CalculateInterest(props){
  let creditValue= props.creditValue;
  let LTV = props.LTV;
  let interestRate = 1;

if(props.id === 7){ // millennium

 if (LTV <=0.601){ interestRate = 7.9}
  if (LTV <= 0.801) {
    if(LTV > 0.601){interestRate = 8 }}
  if (LTV > 0.801) {interestRate = 8.8 }
}
 
 
 if (props.id === 10){interestRate = 7.72}; //ing

 if (props.id === 11){interestRate = 7.83}; //ing
 
if (props.id === 12){
  if (LTV <= 0.501) {
    if(props.creditValue < 199999){interestRate = 7.93}
    if(props.creditValue > 200000){interestRate = 7.93}
  }
  
if (LTV > 0.501) {
  if (LTV <= 0.801) {
    if(props.creditValue < 199999){interestRate = 7.93}
    if(props.creditValue > 200000){interestRate = 7.93}
    }}

if (LTV > 0.801){
  if (LTV <= 0.85) {
    if(props.creditValue < 199999){interestRate = 8.63}
    if(props.creditValue > 200000){interestRate = 8.63}
    }}

if (LTV > 0.8501){
  if (LTV <= 0.901) {
    if(props.creditValue < 199999){interestRate = 8.63}
    if(props.creditValue > 200000){interestRate = 8.63}
    }}

if (LTV > 0.901){
  if (LTV < 1) {
   if(props.creditValue < 199999){interestRate = 8.73}
   if(props.creditValue > 200000){interestRate = 8.73}
}}      
}


if(props.id === 9) {  //PKOBP
    if (LTV <= 0.5) {
        if(props.creditValue < 40000){interestRate = 3.9;}
        if(props.creditValue > 40001){
        if(props.creditValue < 79999){interestRate = 2.99}}
        if(props.creditValue > 80000){
        if(props.creditValue < 119999){interestRate = 2.54}}
        if(props.creditValue > 120000){
        if(props.creditValue < 199999){interestRate = 2.29}}
        if(props.creditValue > 200000){
        if(props.creditValue < 399999){interestRate = 1.8}}
        if(props.creditValue > 400000){
        if(props.creditValue < 699999){interestRate = 1.77}}
        if(props.creditValue > 700000){interestRate = 1.69}
      
        }

      
    if (LTV > 0.501) {
      if (LTV <= 0.7) {
        if(props.creditValue < 40000){interestRate = 4.39;}
        if(props.creditValue > 40001){
        if(props.creditValue < 79999){interestRate = 3.09}}
        if(props.creditValue > 80000){
        if(props.creditValue < 119999){interestRate = 2.59}}
        if(props.creditValue > 120000){
        if(props.creditValue < 199999){interestRate = 2.39}}
        if(props.creditValue > 200000){
        if(props.creditValue < 399999){interestRate = 1.88}}
        if(props.creditValue > 400000){
        if(props.creditValue < 699999){interestRate = 1.86}}
        if(props.creditValue > 700000){interestRate = 1.8}
      
        }}
    
    if (LTV > 0.701){
      if (LTV < 0.8) {
        if(props.creditValue < 40000){interestRate = 4.56;}
        if(props.creditValue > 40001){
        if(props.creditValue < 79999){interestRate = 3.1}}
        if(props.creditValue > 80000){
        if(props.creditValue < 119999){interestRate = 2.61}}
        if(props.creditValue > 120000){
        if(props.creditValue < 199999){interestRate = 2.4}}
        if(props.creditValue > 200000){
        if(props.creditValue < 399999){interestRate = 1.89}}
        if(props.creditValue > 400000){
        if(props.creditValue < 699999){interestRate = 1.87}}
        if(props.creditValue > 700000){interestRate = 1.83}
      
        }}
    
    if (LTV > 0.801){
      if(props.creditValue < 40000){interestRate = 5.41;}
      if(props.creditValue > 40001){
      if(props.creditValue < 79999){interestRate = 3.87}}
      if(props.creditValue > 80000){
      if(props.creditValue < 119999){interestRate = 3.36}}
      if(props.creditValue > 120000){
      if(props.creditValue < 199999){interestRate = 3.17}}
      if(props.creditValue > 200000){
      if(props.creditValue < 399999){interestRate = 2.67}}
      if(props.creditValue > 400000){
      if(props.creditValue < 699999){interestRate = 2.63}}
      if(props.creditValue > 700000){interestRate = 2.59}
    
      }
    }
    
   if (props.id === 1){interestRate  = 7.7}
    
   if (props.id === 2){ interestRate = 7.9}

   if (props.id === 3){interestRate  = 8.2}

   if (props.id === 4){interestRate  = 8.4}

   if (props.id === 5){interestRate  = 8.7}

   if (props.id === 6){interestRate  = 9.2}


   if (props.id === 20){ //mbank stałe promo
    
   if (LTV <0.8){ interestRate = 8.8}
    if (LTV > 0.801) { interestRate = 9.3}

  }

  if (props.id === 22){ // OprMbankStałePromoInt(){
      
   if (LTV <0.8){ interestRate = 8.5}
    if (LTV > 0.801) { interestRate = 9}
      
  }

  if (props.id === 21){ // OprMbankStałePromoAct(){
    
   if (LTV <0.8){ interestRate = 8.7}
    if (LTV > 0.801) { interestRate = 9.2}
      
  }

  if (props.id === 23){ // OprMbankStałeStand(){
   
   if (LTV <0.8){ interestRate = 10.8}
    if (LTV > 0.801) { interestRate = 11.3}
      
  }

  if (props.id === 25){ // OprMbankStałeInt(){
    
   if (LTV <0.8){ interestRate = 10.5}
    if (LTV > 0.801) { interestRate = 11}
      
  }

  if (props.id === 24){ // OprMbankStałeAct(){
    
   if (LTV <0.8){ interestRate = 10.7}
    if (LTV > 0.801) { interestRate = 11.2}

  }

  if (props.id === 26){ // OprMbankZmiennePromo(){
    
   if (LTV <0.8){ interestRate = 2.83}
    if (LTV > 0.801) { interestRate = 3.33}
  
  }

  if (props.id === 28){ // OprMbankZmiennePromoInt(){
    
   if (LTV <0.8){ interestRate = 2.53}
    if (LTV > 0.801) { interestRate = 3.03}

  }

  if (props.id === 27){ // OprMbankZmiennePromoAct(){

   if (LTV <0.8){ interestRate = 2.73}
    if (LTV > 0.801) { interestRate = 3.23}

  }

  if (props.id === 29){ // OprMbankZmienneStand(){
 
   if (LTV <0.8){ interestRate = 4.83}
    if (LTV > 0.801) { interestRate = 5.33}

  }

  if (props.id === 31){ // OprMbankZmienneStandInt(){
  
   if (LTV <0.8){ interestRate = 4.53}
    if (LTV > 0.801) { interestRate = 5.03}

  }

  if (props.id === 30){ // OprMbankZmienneStandAct(){
  
   if (LTV <0.8){ interestRate = 4.73}
    if (LTV > 0.801) { interestRate = 5.23}

  }



  if (props.id === 19){ // OprBośBank(){
 
   if (LTV <0.78){ interestRate = 9.51}
    if (LTV >= 0.78) { interestRate = 9.78}
  
  }


  if (props.id === 13){  //OprPEKAOSA(){
 
   if (LTV <0.8){ interestRate = 8.45}
    if (LTV > 0.801) { interestRate = 8.65}
 
  }

  if (props.id === 14){ // OprPEKAOSACPI(){

   if (LTV <0.8){interestRate = 8.3}
    if (LTV > 0.801) { interestRate = 8.5}
 
  }

  if (props.id === 15){ // OprPEKAOSAZmienne(){

   if (LTV <0.8){ interestRate = 1.99}
    if (LTV > 0.801) { interestRate = 2.6}
  
  }

  
  if (props.id === 16){ // OprPEKAOSAZmienneCPI(){

   if (LTV <0.8){ interestRate = 1.89}
    if (LTV > 0.801) { interestRate = 2.5}

  }

  if (props.id === 17){ // OprPEKAOSAZmienneCPIProwizja(){

   if (LTV <0.8){ interestRate = 1.84}
    if (LTV > 0.801) { interestRate = 2.45}

  }

  if (props.id === 12){ // OprSantander(){

    if (LTV <= 0.501) {
      if(creditValue < 199999){interestRate = 7.93}
      if(creditValue > 200000){interestRate = 7.93}
    }
    
  if (LTV > 0.501) {
    if (LTV <= 0.801) {
      if(creditValue < 199999){interestRate = 7.93}
      if(creditValue > 200000){interestRate = 7.93}
      }}
  
  if (LTV > 0.801){
    if (LTV <= 0.85) {
      if(creditValue < 199999){interestRate = 8.63}
      if(creditValue > 200000){interestRate = 8.63}
      }}
  
 if (LTV > 0.8501){
    if (LTV <= 0.901) {
      if(creditValue < 199999){interestRate = 8.63}
      if(creditValue > 200000){interestRate = 8.63}
      }}

 if (LTV > 0.901){
    if (LTV < 1) {
     if(creditValue < 199999){interestRate = 8.73}
     if(creditValue > 200000){interestRate = 8.73}
 }}      
  

  }

  if (props.id === 38){ //OprSantanderZmienneWew(){
 
    if (LTV <= 0.501) {
      if(creditValue < 199999){interestRate = 2.45}
      if(creditValue > 200000){interestRate = 2.45}
    }
    
  if (LTV > 0.501) {
    if (LTV <= 0.801) {
      if(creditValue < 199999){interestRate = 2.45}
      if(creditValue > 200000){interestRate = 2.45}
      }}
  
  if (LTV > 0.801){
    if (LTV <= 0.85) {
      if(creditValue < 199999){interestRate = 3.09}
      if(creditValue > 200000){interestRate = 3.09}
      }}
  
 if (LTV > 0.8501){
    if (LTV <= 0.901) {
      if(creditValue < 199999){interestRate = 3.09}
      if(creditValue > 200000){interestRate = 3.09}
      }}

 if (LTV > 0.901){
    if (LTV < 1) {
     if(creditValue < 199999){interestRate = 3.09}
     if(creditValue > 200000){interestRate = 3.09}
 }}      

  }
  if (props.id === 39){ // OprSantanderZmienneZew(){
 
    if (LTV <= 0.501) {
      if(creditValue < 199999){interestRate = 2.45}
      if(creditValue > 200000){interestRate = 2.45}
    }
    
  if (LTV > 0.501) {
    if (LTV <= 0.801) {
      if(creditValue < 199999){interestRate = 2.45}
      if(creditValue > 200000){interestRate = 2.45}
      }}
  
  if (LTV > 0.801){
    if (LTV <= 0.85) {
      if(creditValue < 199999){interestRate = 3.19}
      if(creditValue > 200000){interestRate = 3.19}
      }}
  
 if (LTV > 0.8501){
    if (LTV <= 0.901) {
      if(creditValue < 199999){interestRate = 3.19}
      if(creditValue > 200000){interestRate = 3.19}
      }}

 if (LTV > 0.901){
    if (LTV < 1) {
     if(creditValue < 199999){interestRate = 3.19}
     if(creditValue > 200000){interestRate = 3.19}
 }}      
  
  }


  if (props.id === 40){ // OprSantanderZmienneWewSelect(){

    if (LTV <= 0.501) {interestRate = 2.40}
     
  if (LTV > 0.501) {
    if (LTV <= 0.801) {interestRate = 2.40}}
      
  
  if (LTV > 0.801){
    if (LTV <= 0.85) {interestRate = 2.99}}
  
 if (LTV > 0.8501){
    if (LTV <= 0.901) {interestRate = 2.99}}
     

 if (LTV > 0.901){
    if (LTV < 1) {interestRate = 2.99}}
   
  }

  if (props.id === 41){ // OprSantanderZmienneZewSelect(){

  if (LTV <= 0.501) {interestRate = 2.40}
     
  if (LTV > 0.501) {
    if (LTV <= 0.801) {interestRate = 2.40}}
      
  
  if (LTV > 0.801){
    if (LTV <= 0.85) {interestRate = 3.09}}
  
 if (LTV > 0.8501){
    if (LTV <= 0.901) {interestRate = 3.09}}
     

 if (LTV > 0.901){
    if (LTV < 1) {interestRate = 3.09}}
     
  

  }

return interestRate.toFixed(2);
}








export default PaymentRate2;
export {PaymentRateDecreasing}
export {TotalCost}
export {TotalCostDecreasing}
export {Calculate}
export {CalculateInterest}
export {TotalCostFixed}
export {TestTotalCost}
export {TotalCostDecreasingFixed}
export {TotalCostPkobp}
export {TotalCostInne}
